<style>
  #MainDivCat *{
    font-weight: bolder;
    font-size: 14px;
    list-style: none;
  }
</style>

<div class="col-md-12 mb-30" [hidden]="Swicher_File_Tree.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">ISO/IEC 17025 Management</h5>

      <div id="MainDivCat" >
        <ul droppable>
          <li class="MyMoeinListCat_Li" draggable>

            <div class="MyMoeinListCat_Div">
              <span class="MyMoeinListCat_Span">Root</span>
              <i class="fa  fa-plus-circle MyMoeinListCat_Add" (click)="On_Add_Root(templateAdd)"></i>
            </div>

            <app-Protocol17025Chart_Co
              (On_Add_Action)="OnGet_Add_Action(templateAdd,$event)"
              (On_Edit_Action)="OnGet_Edit_Action(templateEdit,$event)"
              (On_Remove_Action)="OnGet_Remove_Action(templateDelete,$event)"

              (On_Up_Action)="OnGet_Up_Action($event)"
              (On_Down_Action)="OnGet_Down_Action($event)"
              (On_Child_Action)="OnGet_Child_Action($event)"
              (On_Cut_Action)="OnGet_Cut_Action($event)"

              (On_File_Action)="OnGet_File_Action($event)"

              [inner_17025_Cat]="DataList_Protocol17025Chart">

            </app-Protocol17025Chart_Co>

          </li>
        </ul>
      </div>

    </div>
  </div>
</div>

<app-Protocol17025ChartFile
  [inner_17025_Cat]="Swicher_File_Tree"
  (On_Back_Action)="OnBack_From_File($event)"
  *ngIf="Swicher_File_Tree.id>0"
  >

</app-Protocol17025ChartFile>


<ng-template #templateEdit>
  <div class="modal-header">
    <h4 class="modal-title pull-left" *ngIf="Selected_Protocol17025Chart.chart_type==1">Edit Step</h4>
    <h4 class="modal-title pull-left" *ngIf="Selected_Protocol17025Chart.chart_type==2">Edit Procedure</h4>
    <h4 class="modal-title pull-left" *ngIf="Selected_Protocol17025Chart.chart_type==3">Edit Form</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Edit.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> Title </label>
        <input [(ngModel)]="title_edit" name="title_edit" type="text" class="form-control"
          placeholder="Type here...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> Code </label>
        <input [(ngModel)]="code_edit" name="code_edit" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="Edit()"> Edit <i class="fa fa-edit"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Edit.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateAdd>
  <div class="modal-header">
    <h4 class="modal-title pull-left" *ngIf="Selected_Protocol17025Chart.chart_type==1">Add Step</h4>
    <h4 class="modal-title pull-left" *ngIf="Selected_Protocol17025Chart.chart_type==2">Add Procedure</h4>
    <h4 class="modal-title pull-left" *ngIf="Selected_Protocol17025Chart.chart_type==3">Add Form</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Add.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> Title </label>
        <input [(ngModel)]="Add_Step_Title" name="title_add" type="text" class="form-control"
          placeholder="Type here...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> Code </label>
        <input [(ngModel)]="Add_Step_Code" name="title_code" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">

    <button *ngIf="Selected_Protocol17025Chart.chart_type==1" type="button" class="btn btn-success" [hidden]="Selected_Protocol17025Chart.id==0" (click)="Add(1)"> Add at Same Level <i class="fa fa-plus"></i></button>
    <button *ngIf="Selected_Protocol17025Chart.chart_type==1" type="button" class="btn btn-info" (click)="Add(0)"> Add at Child Level  <i class="fa fa-plus"></i></button>

    <button *ngIf="Selected_Protocol17025Chart.chart_type==2" type="button" class="btn btn-info" (click)="Add(0)"> Add Procedure  <i class="fa fa-plus"></i></button>
    <button *ngIf="Selected_Protocol17025Chart.chart_type==3" type="button" class="btn btn-info" (click)="Add(0)"> Add Form  <i class="fa fa-plus"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Add.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateDelete>
  <div class="modal-header">
    <h4 class="modal-title pull-left" *ngIf="Selected_Protocol17025Chart.chart_type==1">Delete Step</h4>
    <h4 class="modal-title pull-left" *ngIf="Selected_Protocol17025Chart.chart_type==2">Delete Procedure</h4>
    <h4 class="modal-title pull-left" *ngIf="Selected_Protocol17025Chart.chart_type==3">Delete Form</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-footer">

    <button *ngIf="Selected_Protocol17025Chart.chart_type==1" type="button" class="btn btn-success" (click)="Delete(1)"> Delete and Move Children Up <i class="fa fa-remove"></i></button>
    <button *ngIf="Selected_Protocol17025Chart.chart_type==1" type="button" class="btn btn-info" (click)="Delete(0)"> Delete with Children  <i class="fa fa-remove"></i></button>

    <button *ngIf="Selected_Protocol17025Chart.chart_type==2" type="button" class="btn btn-info" (click)="Delete(0)"> Delete Procedure  <i class="fa fa-remove"></i></button>
    <button *ngIf="Selected_Protocol17025Chart.chart_type==3" type="button" class="btn btn-info" (click)="Delete(0)"> Delete Form  <i class="fa fa-remove"></i></button>

    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>
